import { combineReducers } from 'redux'

import list from './list/slice'

const jobsReducer = combineReducers({
  list,
})

export default jobsReducer
